export default __webpack_public_path__ + "ee51062e697da1b6ededcb20f52ae36b.svg";